import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import { displayTemporaryProfileSaveModal } from '../modal/modalActions'
import { Link } from 'react-router'

export default class SaveTempProfileLink extends PureComponent {

  render() {
    return (
      <Link onClick={ this.handleClick } className='header-register-link'>
        <span key='text' style={ { fontSize: '1.2rem' } }>Amppareiden väliaikainen profiili poistuu</span>
      </Link>
    )
  }

  handleClick = () => {
    this.props.dispatch(displayTemporaryProfileSaveModal())
  }
}

SaveTempProfileLink.propTypes = exact({
  dispatch: PropTypes.func.isRequired,
})
